export default __webpack_public_path__ + "static/embark-board-ab14667e7b08992965cf8110d5459442.webp";